import qs from 'querystring';
import conf from '../conf';

const defaultParams = ['remainingSubscriptions=true', 'availablesPlaces=true'];

const splittedUrl = window.location.href.toString().split('/');
const currentClientToken = splittedUrl[splittedUrl.length - 1].split('?')[0];
const splittedLastPart = splittedUrl[splittedUrl.length - 1].split('?')[1];
const params = splittedLastPart ? splittedLastPart.split('&') : defaultParams;

const { baseUrl } = conf;

const getUrlParams = () => {
  let paramArray = {};

  params.map((item) => {
    const paramItemArray = item.split('=');
    paramArray[paramItemArray[0]] = paramItemArray[1] === 'true';
    return paramArray;
  });

  return paramArray;
};

export const paramArray = getUrlParams();

// GENERIC CALL
export const genericFetch = (url, method) => fetch(url, method)
  .then(response => response.json());

// GENERIC SECU
const getOAuthAuthorization = async () => {
    const oauthAuthorization = await genericFetch(baseUrl + currentClientToken + '/oauth/v2/token', {
      method: 'POST',
      body: qs.stringify(conf.oauthCredentials),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then(obj => `Bearer ${obj.access_token}`);

  return oauthAuthorization;
};

// GENERIC CALL API WITH AUTH
const makeCallApi = getAuthorization => async (url, config = {}) => {
  const Authorization = await getAuthorization();

  let fullUrl = url;
  const params = qs.stringify(config.params);
  if (params !== '') {
    fullUrl = [url, params].join('?')
  }

  return genericFetch(fullUrl, {
    method: 'GET',
    headers: { Authorization }
  });
};

const callApi = makeCallApi(getOAuthAuthorization);
export default callApi;

// GET SHELTERS (Arras)/ STUDIO(bourgogne)
export const getStudio = (config) => callApi(baseUrl + currentClientToken + '/public/v1/studios', config);



// WEBPACK FOOTER //
// src/service/data.js